import React, { Component } from "react";
import { withRouter } from 'react-router-dom';

import classes from "./NavigationProgress.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class NavigationProgress extends Component {

  addonClickHandler = () => {
    if (this.props.location.pathname.indexOf("pay") !== -1) {
      this.props.history.push({
        pathname: "/reviews/addons",
        search: this.props.location.search
      })
    }
  }

  render() {
    let routePath = this.props.location.pathname;
    return (
      <nav className={`${[classes.Nav, classes.NavWhite].join(' ')} u-phoneHide`}>
        <ul className={`u-flex`}>
          <li className={`u-textAlignLeft u-cursorPointer u-block f-fill`}>
            <a className={[classes.Link, routePath.indexOf("details") !== -1 ? classes.LinkActive : null].join(' ')} onClick={() => {
              console.log('Inside First Nav Item');
                this.props.history.push({
                  pathname: "/reviews/details",
                  search: this.props.location.search
                })
              }}>
              {this.props.lob === "hotel" ? 'Review Hotel Details' : 'Review Flight Details'}
            </a>
          </li>
          {this.props.lob === "hotel" ? (
            null
          ) : (
            <React.Fragment>
              <li className={`u-flex justify-content-center align-items-center f-fill`}><span className={`u-inlineBlock u-transformRotate270`}><FontAwesomeIcon icon="angle-down" color="#666" size="1x" /></span></li>
              <li className={`u-textAlignCenter u-cursorPointer u-block f-fill`}>
                <a className={[classes.Link, routePath.indexOf("addons") !== -1 ? classes.LinkActive : null].join(' ')} onClick={this.addonClickHandler}>
                  Add-Ons for you
                </a>
              </li>
            </React.Fragment>
          )}
          <li className={`u-flex justify-content-center align-items-center f-fill`}><span className={`u-inlineBlock u-transformRotate270`}><FontAwesomeIcon icon="angle-down" color="#666" size="1x" /></span></li>
          <li className={`u-textAlignRight u-cursorPointer u-block f-fill`}>
            <a className={[classes.Link, routePath.indexOf("pay") !== -1 ? classes.LinkActive : null].join(' ')}>
                Secure Payment
            </a>
          </li>
        </ul>
      </nav>
    );
  }
};

export default withRouter(NavigationProgress);



// WEBPACK FOOTER //
// ./src/components/NavigationProgress/NavigationProgress.js